export var {
  hasOwnProperty
} = Object.prototype;
export var arrayFromSet = Array.from || function (set) {
  var array = [];
  set.forEach(item => array.push(item));
  return array;
};
export function maybeUnsubscribe(entryOrDep) {
  var {
    unsubscribe
  } = entryOrDep;

  if (typeof unsubscribe === "function") {
    entryOrDep.unsubscribe = void 0;
    unsubscribe();
  }
}